<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-02-23 13:54:22
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-03-01 17:43:02
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/multilingual/mainPage.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <div class="mh-100vh bg-F5F5F5 overflow-hidden border-box pb-20 pt-10" v-if="!isDelete">
      <!-- 卡片 -->
      <MainPageCard :userBaseInfoVo="userBaseInfoVo"></MainPageCard>
      <!-- 按钮 -->
      <MainPageBtn :successTip='successTip' :leftBtnWord='downLoadWord' :qrCodeUrl='userBaseInfoVo.qrCodeUrl' :userBaseInfo="userBaseInfoVo" :rightBtnWord='saveBusinessCard' :vcardParams="vcardParams"></MainPageBtn>
      <!-- 个人介绍 -->
      <MainPageIntroduction :userProfile='userProfile' v-if="userProfile && (userProfile.content != '' || userProfile.attachmentVos.length > 0)" :title='introduceWord'></MainPageIntroduction>
      <!-- 工作经历 -->
      <MainPageResume :recordVos='recordVos' v-if="recordVos && recordVos.length > 0" :title='workExprenice'></MainPageResume>
    </div>
    <div v-else class="d-flex mh-100vh bg-F5F5F5" style=" justify-content: center;align-items: center;flex-direction: column;font-size:16px;color:#262626;">
      <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/common-default-picture/common-no-data.png" alt="" style="width:200px;height:200px;">
      AI名片已被删除
    </div>
  </div>
</template>
<script>
import MainPageCard from './components/MainPageCard.vue'
import MainPageBtn from './components/MainPageBtn.vue'
import MainPageIntroduction from './components/MainPageIntroduction.vue'
import MainPageResume from './components/MainPageResume.vue'

import { handleSenceQrCode, queryUserHomePage } from '@/api/customPageApi'
import { GetQueryString } from '@/utils/utils'
import { translateText } from '@/api/common'
export default {
  name: 'mainPage',
  components: { MainPageCard, MainPageBtn, MainPageIntroduction, MainPageResume },
  data() {
    return {
      vcardParams: {},
      uid: ``,
      headersNormal: {},
      userBaseInfoVo: {},
      userProfile: {},
      recordVos: [],
      downLoadWord: '',
      saveBusinessCard: '',
      introduceWord: '',
      workExprenice: '',
      isDelete: false,
      successTip: '',
    }
  },
  mounted() {
    this.senceKey = GetQueryString(`scenesKey`)
    var headerClientInfo = { language: 'CN', eventKey: 'WeMeet', appKey: `WX_MINI_WEMEET` }
    this.headersNormal = {
      'x-call-client-info': JSON.stringify(headerClientInfo),
    }
    handleSenceQrCode(this.headersNormal, this.senceKey).then((res) => {
      console.log(res)
      this.uid = res.data.jumpPath
      this.vcardParams = JSON.parse(res.data.params)
      this.translateWord(this.vcardParams.language)

      this.queryUserHomePageInfo()
    })
  },
  methods: {
    queryUserHomePageInfo() {
      queryUserHomePage(this.headersNormal, this.uid, this.vcardParams.language).then((res) => {
        console.log(res)
        if (res.code == 12025) {
          this.isDelete = true
          return false
        }
        this.userBaseInfoVo = res.data.userBaseInfoVo
        this.userProfile = res.data.userProfile
        this.recordVos = res.data.recordVos
      })
    },
    async translateWord(language) {
      let params = {
        source: 'CN',
        sourceText: `下载二维码`,
        target: language,
        textType: 'COMMON',
      }
      const { data: downLoadWord } = await translateText(this.headersNormal, params)
      this.downLoadWord = downLoadWord
      params.sourceText = '保存名片'
      const { data: saveBusinessCard } = await translateText(this.headersNormal, params)
      this.saveBusinessCard = saveBusinessCard
      params.sourceText = '图片已生成，请保存。扫描二维码保存联系人'
      const { data: successTip } = await translateText(this.headersNormal, params)
      this.successTip = successTip
       
      if (language == 'EN') {
        this.introduceWord = `About`
        this.workExprenice = `Experience`
      } else {
        params.sourceText = '个人介绍'
        const { data: introduceWord } = await translateText(this.headersNormal, params)
        this.introduceWord = introduceWord
        params.sourceText = '个人履历'
        const { data: workExprenice } = await translateText(this.headersNormal, params)
        this.workExprenice = workExprenice


       
      }

      // const { data : downLoadWord } = await translateText(this.headersNormal, params)
      // this.downLoadWord = downLoadWord
      // params.sourceText = '保存名片'
      // await translateText(params)
    },
  },
}
</script>


<style lang="less" scoped>
.a {
}
</style>